import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '@routes/parent/i18n';
import {SimpleModal} from '@modules/simple-modal';

/**
 * @summary SelectChildModal
 * @extends {AoflElement}
 */
@customElement('select-child-modal')
class SelectChildModal extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of SelectChildModal.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'select-child-modal';

  @property({type: Object, attribute: true})
  currentActivation = {};

  @property({type: Boolean})
  disabled = true;

  toggle(child) {
    if (child.linked) {
      return;
    }

    this.currentActivation.child_profile_id = child.profile_id;
    this.disabled = false;
    this.requestUpdate();
  }

  onSubmit(e) {
    e.preventDefault();
    this.dispatchEvent(new Event('submit'));
  }

  onSkip(e) {
    e.preventDefault();
    this.dispatchEvent(new Event('skip'));
  }

  firstUpdated(changedProperties) {
    this.shadowRoot.querySelector('[tabindex="0"]').focus();
  }

  close() {
    SimpleModal.hide();
  }

  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default SelectChildModal;
